import { render, staticRenderFns } from "./permissions-list.vue?vue&type=template&id=6d9907e3&scoped=true"
import script from "./permissions-list.vue?vue&type=script&lang=js"
export * from "./permissions-list.vue?vue&type=script&lang=js"
import style0 from "./permissions-list.vue?vue&type=style&index=0&id=6d9907e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9907e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9907e3')) {
      api.createRecord('6d9907e3', component.options)
    } else {
      api.reload('6d9907e3', component.options)
    }
    module.hot.accept("./permissions-list.vue?vue&type=template&id=6d9907e3&scoped=true", function () {
      api.rerender('6d9907e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/permissions/list/permissions-list.vue"
export default component.exports